module.exports = __webpack_public_path__ + "static/img/brigantin.2af78fb.png";


//////////////////
// WEBPACK FOOTER
// ./src-detail/img/brigantin.png
// module id = eYhJ
// module chunks = 1